/**
 * One dollar formatter for every payout surface, staff-side and creator-side.
 *
 * Cents show only when there are cents. That matters more than it looks: a
 * payout is a share of lifetime ad spend, so balances routinely land on
 * fractions of a dollar, and a whole-dollar formatter renders a real $0.40
 * still owed as "$0" — a badge that exists to stop "I thought you paid me"
 * emails, saying the thing that starts them.
 */
export function formatUsd(value: number): string {
  return value.toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: Number.isInteger(value) ? 0 : 2,
  });
}
